import classNames from 'classnames'
import { JSX } from 'react'

import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../configs/translations'
import { IMdfInitiativeGroupTotal } from '../model/types'

import styles from './MdfActivitiesInitiativesGroupsTableFooter.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.initiativesGroups

interface IMdfActivitiesInitiativesGroupsTableFooterProps {
  total: IMdfInitiativeGroupTotal | null
  isUsd: boolean
}

const renderMoney = (value: number, isUsd: boolean): JSX.Element | string =>
  value ? getFormattedFinance(value, { withCurrencySign: isUsd, maximumFractionDigits: 0 }) : '-'

export const MdfActivitiesInitiativesGroupsTableFooter = ({
  total,
  isUsd,
}: IMdfActivitiesInitiativesGroupsTableFooterProps) => {
  if (!total) {
    return null
  }

  return (
    <tfoot className={styles.footer}>
      <tr>
        <td className={classNames(styles.cell, styles.totalText)}>
          <Translation text={KEYS.total} />
        </td>
        <td className={classNames(styles.cell, styles.numericColumn, styles.totalText)}>
          {renderMoney(total.planned, isUsd)}
        </td>
        <td className={classNames(styles.cell, styles.numericColumn, styles.totalText)}>
          {renderMoney(total.requested, isUsd)}
        </td>
        <td className={classNames(styles.cell, styles.numericColumn, styles.totalText)}>
          {renderMoney(total.paid, isUsd)}
        </td>
        <td className={classNames(styles.cell, styles.totalText)}>
          {total.coveragePercent === null ? '—' : `${total.coveragePercent}%`}
        </td>
      </tr>
    </tfoot>
  )
}

MdfActivitiesInitiativesGroupsTableFooter.displayName = 'MdfActivitiesInitiativesGroupsTableFooter'
